module.exports = __webpack_public_path__ + "img/pic02.11cde0b5.png";